import { useTranslation } from 'react-i18next';
import { ErrorAlert } from '@/components/ui/ErrorAlert';

/** Shared no-access state for a blocked route or a forbidden patient-tab deeplink. */
export function NoAccess({ message }: { message?: string }) {
  const { t } = useTranslation();
  return (
    <div className="py-8">
      <ErrorAlert message={message ?? t('common.no_access')} />
    </div>
  );
}
